'use es6';

import { CUSTOM_BEHAVIORAL_EVENT } from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { AdapterCache } from '../requestCaches/adaptersCache';
import http from 'hub-http/clients/apiClient';
import createDSAdapter from './createDSAdapter';
import { Map as ImmutableMap, Record } from 'immutable';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
const UPDATER_CACHE_KEY = 'CUSTOM_BEHAVIORAL_EVENTS';
export const fetchedDataCache = new AdapterCache();
export const processedDataCache = new AdapterCache();
export const UnifiedEventRecord = Record({
  fullyQualifiedName: undefined,
  objectTypeId: undefined,
  label: undefined,
  primaryObjectTypeId: undefined
});
export const makeCustomBehavioralEventAdapter = () => {
  function isAssetFamilySupported(assetFamily) {
    return assetFamily === CUSTOM_BEHAVIORAL_EVENT;
  }
  function getFetcherFromProps() {
    return http.get;
  }
  function fetch(httpClient) {
    const url = 'events/internal/v0/app/event-types';
    const cached = fetchedDataCache.get(url);
    if (cached) {
      return cached;
    }
    const request = httpClient(url);
    fetchedDataCache.set(url, request);
    return request;
  }
  function updater(customBehavioralEvents) {
    const cached = processedDataCache.get(UPDATER_CACHE_KEY);
    if (cached) {
      return cached;
    }
    const formatted = customBehavioralEvents.reduce((acc, event) => {
      if (event.eventTypeId.metaType === 'PORTAL_SPECIFIC_EVENT' && event.primaryObjectTypeId === CONTACT_TYPE_ID) {
        const objectTypeId = `6-${event.eventTypeId.innerId}`;
        const label = event.labels.singular || event.fullyQualifiedName;
        return acc.set(objectTypeId, UnifiedEventRecord({
          objectTypeId,
          label,
          fullyQualifiedName: event.fullyQualifiedName,
          primaryObjectTypeId: event.primaryObjectTypeId
        }));
      }
      return acc;
    }, ImmutableMap());
    processedDataCache.set(UPDATER_CACHE_KEY, formatted);
    return formatted;
  }
  return createDSAdapter({
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  });
};
const customBehavioralEventAdapter = makeCustomBehavioralEventAdapter();
export default customBehavioralEventAdapter;